import './footer.css'
export default function Footer() {
    return (
      <div className='main'>
        © 2021 OM Therapy for Wellness created by <a href="https://www.eras.page" className="a">Lucas Eras</a> 
      </div>
    )
}
